import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

type DeleteClientConfirmDialogProps = {
  open: boolean;
  clientName?: string;
  isPendingDeletion?: boolean;
  isDeleting?: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
};

export const DeleteClientConfirmDialog: React.FC<DeleteClientConfirmDialogProps> = ({
  open,
  clientName,
  isPendingDeletion = false,
  isDeleting = false,
  onOpenChange,
  onConfirm,
}) => {
  const displayName = clientName?.trim() || 'this client';

  return (
    <AlertDialog open={open} onOpenChange={(nextOpen) => {
      if (!nextOpen && isDeleting) return;
      onOpenChange(nextOpen);
    }}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {isPendingDeletion ? 'Delete this client now?' : 'Delete this client?'}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {isPendingDeletion
              ? `This permanently deletes ${displayName} and all related data immediately. It skips the 14-day restore window and cannot be undone.`
              : `This permanently deletes ${displayName} and all related data. This cannot be undone.`}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            disabled={isDeleting}
            className="bg-[#b42318] hover:bg-[#8f1c14]"
            onClick={(event) => {
              event.preventDefault();
              onConfirm();
            }}
          >
            {isDeleting ? 'Deleting…' : 'Delete permanently'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
